import {Injectable} from "@angular/core";
import {Subject} from "rxjs";
import {ApiService} from "./api.service";
import {Page} from "../models/page.model";
import {ChatMessagesReq, ChatNewMessageReq} from "../models/chat.model";

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  public isNewChat$: Subject<boolean> = new Subject<boolean>();
  public isNewMessage$: Subject<boolean> = new Subject<boolean>();
  public isNewMessageNotification$: Subject<any> = new Subject<any>();
  public isUpdateMessageNotification$: Subject<any> = new Subject<any>();
  public updateNewMessageCount$: Subject<any> = new Subject<any>();

  constructor(
    private readonly api: ApiService
  ) {
  }

  public async list(req: Page, isLoading: boolean = false): Promise<any> {
    return await this.api.chat.list(req, isLoading).then();
  }

  public async get(id: string, isLoading: boolean = false): Promise<any> {
    return await this.api.chat.get(id, isLoading).then();
  }

  public async req(productId: string, isLoading: boolean = false): Promise<any> {
    return await this.api.chat.req(productId, isLoading).then();
  }

  public async messages(req: ChatMessagesReq, isLoading: boolean = false): Promise<any> {
    return await this.api.chat.messages(req, isLoading).then();
  }

  public async newMessage(req: any, isLoading: boolean = false): Promise<any> {
    return await this.api.chat.newMessage(req, isLoading).then();
  }

  public async updateTotalCountMessage() {
    await this.api.chat.chatUnreadCount().then(resp => {
      if (resp) {
        this.updateNewMessageCount$.next(resp);
      }
    })
  }
}
